import React from 'react';

import './TotalOcc.scss';
import { useIntl } from 'react-intl';
import { formatOPN } from '../../../../../../utils/helpers';

const TotalOcc = ({ data }) => {
  const translate = useIntl();

  const totalInfoData = [
    {
      key: 'a',
      text: translate.formatMessage({ id: 'carbon.form.tableOne' }),
      value: formatOPN(data.dataValidationPoolRewards, 3),
    },
    {
      key: 'b',
      text: translate.formatMessage({ id: 'carbon.form.tableTwo' }),
      value: formatOPN(data.dataReceived, 3),
    },
    {
      key: 'c',
      text: translate.formatMessage({ id: 'carbon.form.tableThree' }),
      value: formatOPN(data.dataPoolRewards, 3),
    },
    {
      key: 'd',
      text: translate.formatMessage({ id: 'carbon.form.tableFour' }),
      value: formatOPN(data.dataEcosystem, 3),
    },
  ];
  return (
    <div className="totalOcc__wrapper">
      {totalInfoData.map((item) => (
        <div className="totalOcc__item" key={item.key}>
          <div className="totalOcc__text">{item.text}</div>
          <div className="totalOcc__value">{item.value}</div>
        </div>
      ))}
    </div>
  );
};

export default TotalOcc;
